// Aggregerar alla namnrymder för sv.
import { account } from "./account";
import { ads } from "./ads";
import { auction } from "./auction";
import { auth } from "./auth";
import { business } from "./business";
import { categories } from "./categories";
import { checkout } from "./checkout";
import { common } from "./common";
import { home } from "./home";
import { inbox } from "./inbox";
import { info } from "./info";
import { legal } from "./legal";
import { nav, footer, errors } from "./nav";
import { menu } from "./menu";
import { notifications } from "./notifications";
import { offers } from "./offers";
import { orders } from "./orders";
import { plans } from "./plans";
import { profile } from "./profile";
import { promo } from "./promo";
import { scan } from "./scan";
import { sell } from "./sell";
import { settings } from "./settings";
import { support } from "./support";

export const sv = {
  account,
  ads,
  auction,
  auth,
  business,
  categories,
  checkout,
  common,
  home,
  inbox,
  info,
  legal,
  nav,
  footer,
  errors,
  menu,
  notifications,
  offers,
  orders,
  plans,
  profile,
  promo,
  scan,
  sell,
  settings,
  support,
} as const;
